var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountPinBoxLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 17.5 10 19.167 8.333 17.5h-4.17A1.662 1.662 0 0 1 2.5 15.837V4.163c0-.919.744-1.663 1.663-1.663h11.674c.919 0 1.663.744 1.663 1.663v11.674c0 .919-.744 1.663-1.663 1.663h-4.17Zm4.166-1.667V4.167H4.167v11.666h4.857l.976.977.976-.977h4.857Zm-9.19-.682a8.314 8.314 0 0 1-1.459-.816 5.829 5.829 0 0 1 4.901-2.668c2 0 3.764 1.006 4.815 2.539a8.32 8.32 0 0 1-1.437.854 4.161 4.161 0 0 0-3.378-1.727c-1.43 0-2.691.72-3.442 1.818ZM10 10.833A2.917 2.917 0 1 1 10 5a2.917 2.917 0 0 1 0 5.833Zm0-1.666a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPinBoxLine);
export default __webpack_public_path__ + "static/media/account-pin-box-line.914acd1c71fad4e6b33c9e0779bee5f2.svg";
export { ForwardRef as ReactComponent };